var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showSingleItem || _vm.crumbs.length > 1,
          expression: "showSingleItem || crumbs.length > 1",
        },
      ],
      class: { "breadcrumbs-collapsed": _vm.collapsedCrumbs.length },
    },
    [
      _c(
        "nav",
        _vm._b(
          {
            staticClass: "breadcrumbs",
            attrs: { "aria-label": _vm.$attrs.ariaLabel },
          },
          "nav",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapsedCrumbs.length,
                  expression: "collapsedCrumbs.length",
                },
              ],
              staticClass: "breadcrumbs-dropdown-wrapper",
            },
            [
              _c("KIconButton", {
                attrs: {
                  size: "small",
                  icon: _vm.showDropdown ? "chevronUp" : "chevronDown",
                  appearance: "raised-button",
                },
                on: {
                  click: function ($event) {
                    _vm.showDropdown = !_vm.showDropdown
                  },
                },
              }),
              _vm.showDropdown
                ? _c(
                    "div",
                    {
                      staticClass: "breadcrumbs-dropdown",
                      style: { background: _vm.$themeTokens.surface },
                    },
                    [
                      _c(
                        "ol",
                        { staticClass: "breadcrumbs-dropdown-items" },
                        _vm._l(_vm.collapsedCrumbs, function (crumb, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "breadcrumbs-dropdown-item",
                            },
                            [
                              crumb.link
                                ? _c("KRouterLink", {
                                    staticClass: "krouter-item",
                                    attrs: { text: crumb.text, to: crumb.link },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "text",
                                          fn: function ({ text }) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "breadcrumbs-crumb-text",
                                                  attrs: { dir: "auto" },
                                                },
                                                [_vm._v(_vm._s(text))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c("span", { attrs: { dir: "auto" } }, [
                                    _vm._v(_vm._s(crumb.text)),
                                  ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "ol",
            { staticClass: "breadcrumbs-visible-items" },
            [
              _vm._l(_vm.crumbs, function (crumb, index) {
                return [
                  index !== _vm.crumbs.length - 1
                    ? _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !crumb.collapsed,
                              expression: "!crumb.collapsed",
                            },
                          ],
                          key: index,
                          staticClass:
                            "breadcrumbs-visible-item breadcrumbs-visible-item-notlast",
                        },
                        [
                          crumb.link
                            ? _c("KRouterLink", {
                                attrs: {
                                  text: crumb.text,
                                  to: crumb.link,
                                  dir: "auto",
                                  title: crumb.text,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "text",
                                      fn: function ({ text }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "breadcrumbs-crumb-text",
                                              attrs: { title: text },
                                            },
                                            [_vm._v(_vm._s(text))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _c("span", { attrs: { title: crumb.text } }, [
                                _vm._v(_vm._s(crumb.text)),
                              ]),
                        ],
                        1
                      )
                    : _c(
                        "li",
                        {
                          key: index,
                          staticClass:
                            "breadcrumb-visible-item-last breadcrumbs-visible-item",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "breadcrumbs-crumb-text",
                              style: { maxWidth: _vm.lastBreadcrumbMaxWidth },
                              attrs: { dir: "auto", title: crumb.text },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(crumb.text) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "breadcrumbs breadcrumbs-offscreen",
          attrs: { "aria-hidden": "true" },
        },
        [
          _c(
            "ol",
            { staticClass: "breadcrumbs-visible-items" },
            [
              _vm._l(_vm.crumbs, function (crumb, index) {
                return [
                  index !== _vm.crumbs.length - 1
                    ? _c(
                        "li",
                        {
                          key: index,
                          ref: `crumb${index}`,
                          refInFor: true,
                          staticClass:
                            "breadcrumbs-visible-item breadcrumbs-visible-item-notlast",
                        },
                        [
                          crumb.link
                            ? _c("KRouterLink", {
                                attrs: {
                                  text: crumb.text,
                                  to: crumb.link,
                                  tabindex: "-1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "text",
                                      fn: function ({ text }) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "breadcrumbs-crumb-text",
                                            },
                                            [_vm._v(_vm._s(text))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _c("span", [_vm._v(_vm._s(crumb.text))]),
                        ],
                        1
                      )
                    : _c(
                        "li",
                        {
                          key: index,
                          ref: `crumb${index}`,
                          refInFor: true,
                          staticClass:
                            "breadcrumb-visible-item-last breadcrumbs-visible-item",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "breadcrumbs-crumb-text",
                              style: { maxWidth: _vm.lastBreadcrumbMaxWidth },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(crumb.text) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }